import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import { useMessageById } from '../../../hooks';
import styles from './style/index.less';
import { genRichText, formateImageWebp } from '../../../utils';
var BusinessCard = function (props) {
    var messageId = props.messageId;
    var payload = useMessageById(messageId).payload;
    var _a = useComponents(), View = _a.View, Image = _a.Image;
    return (React.createElement(View, { className: styles['busniess-card-container'] },
        React.createElement(View, { className: styles['busniess-card'] },
            React.createElement(Image, { className: styles['business-card-img'], src: formateImageWebp(payload.img), imageWidth: 84, imageHeight: 84 }),
            React.createElement(View, { className: styles['business-card-wrap'] },
                React.createElement(View, { className: styles['business-card-title'] }, payload.title),
                React.createElement("div", { dangerouslySetInnerHTML: { __html: genRichText(payload.content) }, className: styles['business-card-content'] })))));
};
export default BusinessCard;
